import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { UPDATE_RECOMMENDATIONS_TEXT } from '../../../constants/shared/InstructionConstants';
import Button from '../../../components/button/Button';
import { DATE_FORMAT } from '../../../constants/shared/CommonConstants';
import './UpdateRecommendations.scss';

const UpdateRecommendations = ({
    buttonText,
    date,
    clickHandler,
    classNames,
    classNamesIcons,
    isDisabled,
}) => (
    <div className="update-recommendations">
        <Button
            className={`btn checkpoint-btn ${classNames}`}
            onClick={clickHandler}
            text={
                <>
                    <i className={classNamesIcons} />
                    {buttonText}
                </>
            }
            isDisabled={isDisabled}
        />
        {date && (
            <div className="checkpoint-section">
                Last Updated:&nbsp;
                <strong>{format(new Date(date), DATE_FORMAT.DATE_TIME)}</strong>
            </div>
        )}
    </div>
);

UpdateRecommendations.defaultProps = {
    buttonText: UPDATE_RECOMMENDATIONS_TEXT,
    date: null,
    clickHandler: () => {},
    isDisabled: false,
    classNames: '',
    classNamesIcons: 'icon-amplify-refresh',
};

UpdateRecommendations.propTypes = {
    buttonText: PropTypes.string,
    date: PropTypes.string,
    clickHandler: PropTypes.func,
    isDisabled: PropTypes.bool,
    classNames: PropTypes.string,
    classNamesIcons: PropTypes.string,
};

export default UpdateRecommendations;
